import React from 'react';
import { Radio } from 'antd';
import styled from 'styled-components';


/**
 * 切换组件
 * @param {*} props 
 * @returns 
 */
function RadioGroup(props) {
  const {value, onChange, children} = props;
  return (
    <RadioContainer>
      <Radio.Group value={value} onChange={onChange}>
        {children}
      </Radio.Group>
    </RadioContainer>
  )
}

const RadioContainer = styled.div`
  .ant-radio-wrapper {
    position: relaive;
    font-size: 16px;
    margin-right: 36px;
    span {
      color: #606266;
      padding: 0;
    }
    .ant-radio {
      display: none;
      .ant-radio-inner {
        background-color: transparent;
      }
    }
  }

  .ant-radio-wrapper-checked {
    &:before {
      content: "";
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 100%;
      height: 2px;
      background: #1989FA;
    }
    span {
      color: #409EFF;
    }

    .ant-radio-checked {
      .ant-radio-inner {
        background-color: transparent;
      }
    }
  }
`


export default RadioGroup;